import WidgetLocator from './WidgetLocator';

export default WidgetLocator;
